<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-school-partner" data-bs-toggle="modal" data-bs-target="#school-partner-modal-form">Klik</button>
        <div class="modal" id="school-partner-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    Daftar Sekolah
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <form>
                                    <div class="input-group input-group-flush input-group-merge input-group-reverse">
                                        <input class="form-control list-search" type="search" placeholder="Cari data sekolah disini..." v-model="keyword">
                                            <span class="input-group-text">
                                            <i class="fa-solid fa-search"></i>
                                        </span>
                                    </div>
                                </form>
                            </div>

                            <div v-if="filteredData.length > 0" class="table-responsive">
                                <table class="table table-sm table-hover card-table">
                                    <thead>
                                        <tr>
                                            <th>Nama Sekolah</th>
                                            <th>Kabupaten</th>
                                            <th>Provinsi</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody class="list fs-base">
                                        <tr v-for="(item, index) in filteredData" :key="index">
                                            <td class="font-bold">{{ item.name }}</td>
                                            <td>{{ item.city_name }}</td>
                                            <td>{{ item.province_name }}</td>
                                            <td>
                                                <span v-if="item.partner == 1" class="badge bg-primary"><i class="fa-solid fa-check-circle me-2"></i>Mitra</span>
                                                <span v-if="item.partner == 0" class="badge bg-dark">Bukan Mitra</span>
                                            </td>
                                            <td>
                                                <button v-if="item.partner == 0" type="button" class="btn btn-white btn-sm" v-on:click="setPartner(item.id, 1)"><i class="fa-solid fa-plus me-3"></i>Jadikan Mitra</button>
                                                <button v-if="item.partner == 1" type="button" class="btn btn-white-naked btn-sm text-danger" v-on:click="setPartner(item.id, 0)"><i class="fa-solid fa-trash-can me-3"></i>Hapus Mitra</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="filteredData.length < 1" class="mt-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-block text-center py-4">
                                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center justify-content-between border-top pt-4">
                            <div class="d-block small">
                                <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                            </div>
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-school-partner">
                                    <div class="btn-s-1-inner">Tutup</div>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SchoolPartnerForm',
    data() {
        return {
            data_school     : [],
            submitted       : false,
            waiting         : false,
            keyword         : '',
        }
    },
    computed: {
        filteredData() {
            const keyword = this.keyword.toLowerCase();
            return this.data_school.filter(item => {
                const name = item.name.toLowerCase();
                return name.includes(keyword);
            });
        },
    },
    methods: {
        loadForm: function() {
            this.getDataSchool();
            document.getElementById('btn-modal-school-partner').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-school-partner').click();
            this.$parent.$children[0].$children[0].getData();
        },
        getDataSchool: function() {
            let uri         = process.env.VUE_APP_APIHOST+'school/list';
            this.$http.get(uri,{
                params : {
                    limit : 1000,
                    partner  : 1
                }
            }).then(res => {
                this.data_school = res.data.data;                
            });
        },
        setPartner: function(id="", partner="") {
            let desc = "menghapus";
            
            if(partner == '1') {
                desc = "menambahkan";
            }
            this.$swal({
                icon: 'info',
                title: 'Konfirmasi Mitra',
                text: 'Apakah kamu yakin ingin '+desc+' status mitra pada sekolah ini?',
                confirmButtonText: 'Konfirmasi',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'school/update-partner', {
                    id: id,
                    partner: partner
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.reloadData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
            
        }
    },
}
</script>
